import { adminGuard } from "./guards.js";

const HubSpotSyncIssueList = () => import("../Views/HubSpotSyncIssue/HubSpotSyncIssueList.vue");

export const hubspotSyncIssueRoutes = [
    {
        path: "/hubspot-sync-issues",
        name: "hubspot-sync-issues.list",
        component: HubSpotSyncIssueList,
        beforeEnter: adminGuard,
        meta: {
            menu: {
                parent: 'hubspot-sync-issues',
                child: null
            },
            breadcrumb: {
                title: "Erreurs HubSpot",
                nav: {
                    all: {
                        active: "Cas à traiter",
                        inactive: []
                    }
                }
            }
        },
    }
];
